exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__price___1uy-d{font-size:20px;text-align:left;font-family:Poppins-Light;letter-spacing:.6px;line-height:1;color:#c1887f;margin:0 auto}.style__priceHeading___1oZDH{font-family:PlayfairDisplay-Regular;font-size:16px;letter-spacing:1px;color:#000;margin-top:10px;margin-bottom:5px}", ""]);

// exports
exports.locals = {
	"price": "style__price___1uy-d",
	"priceHeading": "style__priceHeading___1oZDH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/jewelry-price-breakdown/style.css
// module id = 685
// module chunks = 0